import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const uploadBulkShortVideoApi = createAsyncThunk(
  "short-video-bulk/upload",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.post(apiRoutes.shortVideosAction("upload", 1), data, { headers: { "Content-Type": "multipart/form-data" } })

      return response?.data;
    } catch (error) {
      //console.log("error",error);
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" }
const uploadBulkShortVideoSlice = createSlice({
  name: "short_video_bulk_upload",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetImage: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(uploadBulkShortVideoApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(uploadBulkShortVideoApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(uploadBulkShortVideoApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetImage } = uploadBulkShortVideoSlice.actions;
export const uploadBulkShortVideoReducer = uploadBulkShortVideoSlice.reducer;
